import React from 'react';
import { X } from 'lucide-react';

export const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black/90 backdrop-blur-sm transition-opacity" 
        onClick={onClose} 
      />
      
      {/* Content Container */}
      <div className="relative z-10 w-full max-w-7xl flex flex-col items-center justify-center">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 p-2 text-white/70 hover:text-white transition-colors"
          aria-label="Close modal"
        >
          <X className="w-8 h-8 sm:w-10 sm:h-10" />
        </button>
        
        <div className="w-full flex justify-center items-center">
          {children}
        </div>
      </div>
    </div>
  );
};

export const ImageModal = ({ isOpen, onClose, imgSrc }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <img
      src={imgSrc}
      alt="Enlarged view"
      className="max-w-full max-h-[85vh] object-contain shadow-2xl rounded-sm"
    />
  </Modal>
);

export const VideoModal = ({ isOpen, onClose, videoId }) => (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative w-full aspect-video max-w-4xl shadow-2xl">
        <iframe
          className="w-full h-full rounded-lg"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </Modal>
  );
  
  